export const statusesForbiddenToAdjust = ['DRAFT', 'CANCELLED', 'VERIFIED', 'PAID_PARTIALLY', 'PAID'];
